export default {
  GOOD: 3,
  MIDDING: 2,
  BAD: 1,
};
